export default __webpack_public_path__ + "static/media/production.06046dbe.jpg";